import { useTranslation } from 'react-i18next';

import { Dropdown } from '@innovamat/glimmer-components';
import { getRegisterLanguagesByRegion } from '@innovamat/localization';
import { useGetUserRegion } from '../../../hooks/use-user-region';

function LanguageSelector(): JSX.Element {
  const { t, i18n } = useTranslation();

  const urlRegion = useGetUserRegion();
  const languages = getRegisterLanguagesByRegion(urlRegion);

  const languageOptions = languages?.map((code) => ({
    code,
    label: t(`language.${code}`),
  }));

  const handleSelectLanguage = async (languageLocale: string) => {
    await i18n.changeLanguage(languageLocale);
  };

  return (
    <Dropdown closeOnSelectItem>
      <Dropdown.Toggle
        label={t(`language.${i18n.language}`)}
        variant="tertiary"
      />
      <Dropdown.Content position="bottomLeft">
        {languageOptions.map((option) => (
          <Dropdown.Item
            key={option.code}
            state="active"
            dataTestId={`language-option-${option.code}`}
            onSelectItem={() => handleSelectLanguage(option.code)}
          >
            {option.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Content>
    </Dropdown>
  );
}

export { LanguageSelector };
